'use client'

import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider
} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { AiraloPackage } from 'lib/airlo-api/getPackages'
import { getPackageById } from 'lib/airlo-api/getPackageById'

import { getUser } from 'lib/actions/partners/auth'

import { fetchClientSecret } from '../actions/stripe'
import { useCallback, useEffect, useState } from 'react'

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY)

type CheckoutProps = {
  plan: string
  code: string
  lang?: string
}

export default function Checkout({ plan, code, lang }: CheckoutProps) {
  const [airaloPackage, setAiraloPackage] = useState<AiraloPackage>(null)
  const [userEmail, setUserEmail] = useState<string | null>(null)

  const fetchPackage = useCallback(async () => {
    const userEmail = await getUser()
    if (userEmail) {
      setUserEmail(userEmail)
    }
    if (!plan || !code) return
    const packageData = await getPackageById(plan, code, !!userEmail)
    if (packageData) {
      setAiraloPackage(packageData)
    }
  }, [plan, code])

  useEffect(() => {
    fetchPackage()
  }, [fetchPackage])

  if (!airaloPackage) {
    return null
  }

  console.log('[Checkout] Airalo Package:', airaloPackage)

  const productData = {
    name: airaloPackage.label,
    description: airaloPackage.title,
    images: [airaloPackage.image],
    metadata: {
      planId: airaloPackage.id.replaceAll('plus', '+'),
      country: airaloPackage.value,
      countryCode: airaloPackage.countryCode,
      planTitle: airaloPackage.title,
      price: airaloPackage.price.toFixed(2),
      wholesalePrice: airaloPackage.wholesalePrice.toFixed(2),
      revenue: airaloPackage.revenue.toFixed(2),
      priceCents: Math.round(airaloPackage.price * 100),
      gb: airaloPackage.gb.toString(),
      partnerId: userEmail
    }
  }

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{ 
          fetchClientSecret: () => fetchClientSecret(productData, lang)
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}
